import { PurchaseRepository } from 'application/repositories/PurchaseRepository';
import {
    PurchaseCompanyPayload,
    PurchaseCompanyPayloadStep2,
    PurchaseCompanyResultEntity,
} from 'domain/entities/PurchaseCompanyEntity';
import {
    FamilyPayload,
    PurchasePayload,
    PurchaseResulttEntity,
    PurchaseStep3Payload,
    RegistMemberIndivPayload,
} from 'domain/entities/PurchaseEntity';
import axiosConfig from 'infrastructure/config/axios';

export class PurchaseAPI implements PurchaseRepository {
    async getDefaultInfo(payload: {
        offerId?: number | undefined;
    }): Promise<PurchaseResulttEntity> {
        const API_URL = `/purchase/info-default-individual/${payload.offerId ?? 0}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async getDefaultInfoStep2(payload: {
        offerId?: number | undefined;
    }): Promise<PurchaseResulttEntity> {
        const API_URL = `/purchase/info-default-individual-step-2/${payload.offerId ?? 0}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async getDefaultInfoStep3(payload: {
        listed_property_id?: number;
        purchasePrice?: number;
        purchaseOfferId?: number;
        procedureId?: number;
        loanUseStatus?: number;
    }): Promise<PurchaseResulttEntity> {
        const API_URL = `/purchase/get-individual-step-3`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params: payload });
        return response.data;
    }

    async savePurchaseIndividualStep1(payload: PurchasePayload): Promise<any> {
        const API_URL = `/purchase/save-individual-step-1`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async savePurchaseIndividualStep2(payload: FamilyPayload): Promise<any> {
        const API_URL = `/purchase/save-individual-step-2`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async savePurchaseIndividualStep3(payload: PurchaseStep3Payload): Promise<any> {
        const API_URL = `/purchase/save-individual-step-3`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async registerMemberIndiv(payload: RegistMemberIndivPayload): Promise<any> {
        const API_URL = `/purchase/confirm-register-individual`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async getDefaultInfoCompany(payload: {
        offerId?: number;
    }): Promise<PurchaseCompanyResultEntity> {
        const API_URL = `/property/payment/get-default/${payload.offerId ?? 0}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async getDefaultInfoCompanyStep2(payload: {
        listedPropertyId?: number;
        purchasePrice?: number;
        offerId?: number;
    }): Promise<PurchaseCompanyResultEntity> {
        const API_URL = `/property/get-info/${payload.listedPropertyId ?? 0}?purchaseOfferId=${payload.offerId ?? 0}&purchasePrice=${payload.purchasePrice ?? 0}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }
    async savePurchaseCompanyStep1(payload: PurchaseCompanyPayload): Promise<any> {
        const API_URL = `/property/payment/register-corporation-step-1`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async savePurchaseCompanyStep2(payload: PurchaseCompanyPayloadStep2): Promise<any> {
        const API_URL = `/property/payment/register-corporation-step-2`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async registerMemberCompany(payload: RegistMemberIndivPayload): Promise<any> {
        const API_URL = `/property/payment/confirm-register`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }
}
